import {
  reactive, ref,
} from 'vue';
import { definitions } from '@/types/api';
import axios from '@/axios/api';
import { Router } from 'vue-router';
import { message } from 'ant-design-vue';
import { CustomCaseModalsI, CustomCasePaginationI } from './interfaces';

export class CustomCase {
  caseList = ref<definitions['CustomCase'][]>([]);

  activeCaseId = '';

  pagination = reactive({
    pageNo: 1,
    pageSize: 6,
    totals: 0,
  }) as CustomCasePaginationI;

  modals = reactive({
    modalCopy: false,
    modalDelete: false,
    deleting: false,
    copying: false,
  }) as CustomCaseModalsI;

  async getCaseList() {
    try {
      const { data } = await axios.queryAllCustomCase(this.pagination.pageSize, this.pagination.pageNo);
      if (data.data.list) {
        this.caseList.value = data.data.list as definitions['CustomCase'][];
        this.pagination.totals = data.data.totalRecords;
      } else {
        this.caseList.value = [];
        this.pagination.totals = 0;
      }
      return data;
    } catch (e) {
      return e;
    }
  }

  async delCase(id: string) {
    try {
      this.modals.deleting = true;
      const { data } = await axios.deleteCustomCaseById(id);
      if (data.success) {
        message.success('删除成功');
      } else {
        message.error(data.message);
      }
      await this.getCaseList();
      return data;
    } catch (e) {
      return e;
    } finally {
      this.modals.deleting = false;
    }
  }

  // async copyCase(id: string) {
  //   try {
  //     await setTimeout(() => ({}), 1);
  //     return {};
  //   } catch (e) {
  //     return e;
  //   }
  // }
}

class CustomCaseController {
  customCase!: CustomCase;

  router!: Router;

  constructor(ccase: CustomCase, router: Router) {
    this.customCase = ccase;
    this.router = router;
    this.customCase.getCaseList();
  }

  handlePageChange(pageNo: number) {
    this.customCase.pagination.pageNo = pageNo;
    this.customCase.getCaseList();
  }

  handleEditClick(id: string) {
    this.customCase.activeCaseId = id;
    this.router.push({
      path: `/Teacher/customCase/edit/${this.customCase.activeCaseId}`,
      query: {
        isEdit: 'edit',
      },
    });
  }

  handleCopyClick(id: string) {
    this.customCase.activeCaseId = id;
    message.info('该功能正在开发中');
    // this.customCase.modals.modalCopy = true;
  }

  handleDeleteClick(id: string) {
    this.customCase.activeCaseId = id;
    this.customCase.modals.modalDelete = true;
  }

  confirmModalCopy() {
    this.customCase.modals.modalCopy = false;
  }

  cancelModalCopy() {
    this.customCase.modals.modalCopy = false;
  }

  async confirmModalDelete() {
    await this.customCase.delCase(this.customCase.activeCaseId);
    this.customCase.modals.modalDelete = false;
  }

  cancelModalDelete() {
    this.customCase.modals.modalDelete = false;
  }
}

export default CustomCaseController;
